<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
	class?: HTMLAttributes['class']
}>()
</script>

<template>
	<div :class="cn('flex items-center py-3 px-6 bg-gray-50 rounded-b-xl', props.class)">
		<slot />
	</div>
</template>
